import { useFlags } from 'flagsmith/react';

export const useFeatureFlag = (flag: string) => {
  const flags = useFlags([flag]);
  const result = flags[flag];
  return result;
};
